/**
 * Test signup CTA copy on the mobile and desktop headers
 */ export var HEADER_NAV_SIGNUP_CTA_COPY_120224 = 'HEADER_NAV_SIGNUP_CTA_COPY_120224';
